import { ArrowRightGlobalNavigation } from 'src/components/icons/ArrowRightGlobalNavigation'
import { useMenu } from 'src/contexts/menu-context'
import type { ParentAndLinkItemProps } from '../../../global-navigation'
import { hasNextLevel, isItemInPath } from '../../../utils'

export const Basic = ({ item, level, position }: ParentAndLinkItemProps) => {
  const { state } = useMenu()

  return (
    <div
      className={`py-2 cursor-pointer text-black ${
        isItemInPath(state, level, position) ? 'underline' : ''
      }`}
    >
      <div
        className={`text-base font-normal tracking-[0.08px] text-[#000] flex flex-row justify-between items-center`}
      >
        <span className="block">{item.label}</span>
        {hasNextLevel(item) && (
          <span className="block w-6 h-6">
            <ArrowRightGlobalNavigation />
          </span>
        )}
      </div>
    </div>
  )
}
